import Plugin from 'src/plugin-system/plugin.class';
import '@lottiefiles/lottie-player';
export default class LottiePlayerPlugin extends Plugin {
    init() {
        this.el.shadowRoot?.querySelector('svg')?.setAttribute('preserveAspectRatio', 'none');
    }
}
